import angular from 'angular'
import relatedItemsComponent from './relatedItems.component'

// TODO: this is not a proper component because the controller works on the
// story object - refactor that out to a pub/sub point on the service
//

export default angular
  .module('ellipsis.relatedItems', [])
  .component('relatedItems', relatedItemsComponent)
